import { FunctionComponent } from "react";
import { CartesianGrid, XAxis, YAxis, Label, Bar, Tooltip as ChartTooltip } from "recharts";
import { CustomizedAxisTick, CustomizedBarLabel, CustomTooltip } from "../ChartUtil";
import BaseBarChart from "./BaseBarChart";
import { colorsLight, Body1 } from "@coherehealth/common";

export interface CaseCountChartData {
  name: string;
  workedCases: number;
  incomingCases: number;
}
interface CaseCountProps {
  data: CaseCountChartData[];
  hourly?: boolean;
  agent?: boolean;
}

const CaseCountChart = ({ data, hourly, agent }: CaseCountProps) => {
  return (
    <BaseBarChart data={data}>
      <CartesianGrid stroke="rgba(0, 0, 0, 0.08)" vertical={false} />
      <XAxis
        dataKey="name"
        axisLine={{ stroke: "rgba(0, 0, 0, 0.08)" }}
        tickLine={false}
        tick={(props) => <CustomizedAxisTick hourly={hourly} {...props} />}
        minTickGap={-250}
      />
      <YAxis
        axisLine={{ stroke: "rgba(0, 0, 0, 0.08)" }}
        tickLine={{ stroke: "rgba(0, 0, 0, 0.08)" }}
        stroke={colorsLight.font.light}
        type="number"
        tickCount={4}
        interval={0}
        tick={{
          fontFamily: "Figtree, sans-serif",
          fontWeight: 600,
          fontSize: "15px",
          letterSpacing: "0px",
        }}
        domain={[0, (dataMax: number) => +(dataMax * 1.33).toFixed(1)]}
      >
        <Label
          style={{
            textAnchor: "middle",
            fill: colorsLight.font.secondary,
            fontFamily: "Figtree, sans-serif",
            fontWeight: 600,
            fontSize: "15px",
            letterSpacing: "0px",
          }}
          angle={270}
          value={"Case count"}
          position="insideLeft"
        />
      </YAxis>
      <ChartTooltip content={<CustomTooltip Content={TooltipContent} />} wrapperStyle={{ outline: "none" }} />
      <Bar isAnimationActive={false} dataKey="workedCases" fill="#3E276A" label={CustomizedBarLabel} />
      {!agent && <Bar isAnimationActive={false} dataKey="incomingCases" fill="#32C9A8" label={CustomizedBarLabel} />}
    </BaseBarChart>
  );
};

const TooltipContent: FunctionComponent<React.PropsWithChildren<{ payload: any }>> = ({ payload }) => {
  return (
    <div style={{ margin: "5px" }}>
      <Body1 style={{ marginBottom: "20px" }}>Case Count</Body1>
      <Body1>
        Completed Cases: <span style={{ color: "#D8BFD8" }}>{payload[0].value}</span>
      </Body1>
      {payload[1] && (
        <Body1>
          Incoming Cases: <span style={{ color: payload[1].fill }}>{payload[1].value}</span>
        </Body1>
      )}
    </div>
  );
};

export default CaseCountChart;
